import { render, staticRenderFns } from "./bindEmail.vue?vue&type=template&id=451a20f0&scoped=true&"
import script from "./bindEmail.vue?vue&type=script&lang=js&"
export * from "./bindEmail.vue?vue&type=script&lang=js&"
import style0 from "./bindEmail.vue?vue&type=style&index=0&id=451a20f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a20f0",
  null
  
)

export default component.exports